import {signal} from "@preact/signals-react";

//Customer Table
export const customerDetailsFilters = signal({})

//User Table
export const userDetailsFilters = signal({})
export const userDetailModalFilters = signal({})
export const reloadUserDetailsFilters = signal(false)
export const accessOptions = signal([])

//User Update Drawer
export const userDrawerFilters = signal({})

export const reloadCustomerModulesFilters = signal(false)

export const resetManagementCustomerCrudsFilters = () => {
    customerDetailsFilters.value = {}
    userDetailsFilters.value = {}
    userDetailModalFilters.value = {}
    userDrawerFilters.value = {}
    reloadUserDetailsFilters.value = false
    reloadCustomerModulesFilters.value = false
    accessOptions.value = []
}